export function formatCurrency(amount: number, currency: string = 'EUR') {
    return new Intl.NumberFormat('en-IE', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount).replace('€', '') + ' €'; // Clean generic format like "1,400 €"
}

export function formatDate(dateString: string) {
    if (!dateString) return '—';

    const date = new Date(dateString);
    // Ensure we don't hit Invalid Date
    if (isNaN(date.getTime())) return dateString;

    return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    }).format(date); // Format like "04 Mar 2026"
}

export function generateId(prefix: string) {
    return `${prefix}_${Math.random().toString(36).substr(2, 9)}`;
}
